import { render } from "./FlyoutMenuSmallItems.vue?vue&type=template&id=084d804e&scoped=true"
import script from "./FlyoutMenuSmallItems.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyoutMenuSmallItems.vue?vue&type=script&setup=true&lang=js"

import "./FlyoutMenuSmallItems.vue?vue&type=style&index=0&id=084d804e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084d804e"],['__file',"src/components/Ui/FlyoutMenuSmallItems.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "084d804e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('084d804e', __exports__)) {
    api.reload('084d804e', __exports__)
  }
  
  module.hot.accept("./FlyoutMenuSmallItems.vue?vue&type=template&id=084d804e&scoped=true", () => {
    api.rerender('084d804e', render)
  })

}


export default __exports__